import { $t } from '@/composables/translation'
import { CustomField } from '@/components/Fields/dataObjects/CustomField'
import {
  CustomFieldVisibility,
  CustomFieldType,
  TypeSupportingCustomFieldValues,
  CustomFieldListFragment,
  CustomFieldCustomFieldOptionInput,
 CustomFieldDetailFragment } from '@/gql/graphql'
import { CustomFieldSettings } from '@/components/Fields/dataObjects/CustomFieldSettings'
import { CustomFieldOption } from '@/components/Fields/dataObjects/CustomFieldOption'
import { useFragment } from '@/gql'
import { CustomFieldOptionFragment } from '@/components/Fields/graphql/fragments'

export abstract class AbstractCustomField implements CustomField {
  id: string | null
  appliesTo: TypeSupportingCustomFieldValues
  title: string | null
  slug: string | null
  description: string | null
  visibility: CustomFieldVisibility
  approval: boolean
  apiOnly: boolean
  settings: CustomFieldSettings
  customFieldOptions: Array<CustomFieldOption>
  isUsedInFieldValues: boolean
  viewerCanUpdate: boolean
  abstract readonly fieldType: CustomFieldType

  // Constructor is tinkered to receive data from GraphQL
  constructor(
    field:
      | (Pick<CustomFieldDetailFragment, 'appliesTo'> & Partial<CustomFieldDetailFragment>)
      | (Pick<CustomFieldListFragment, 'appliesTo'> & Partial<CustomFieldListFragment>),
  ) {
    this.id = field.id || null
    this.appliesTo = field.appliesTo
    this.title = field.title || null
    this.slug = field.slug || null
    this.description = 'description' in field ? field.description || null : null
    this.visibility = field.visibility || CustomFieldVisibility.Internal
    this.approval = field.approval || false
    this.apiOnly = field.apiOnly || false
    this.customFieldOptions = (
      'customFieldOptions' in field ? field.customFieldOptions || [] : []
    ).map<CustomFieldOption>(
      (value) => new CustomFieldOption(useFragment(CustomFieldOptionFragment, value)),
    )
    this.settings = new CustomFieldSettings(field.settings || { validation: [] })
    this.isUsedInFieldValues = field.isUsedInFieldValues || false
    this.viewerCanUpdate = field.viewerCanUpdate || false
  }

  exists() {
    return this.id !== null
  }

  displayValidations() {
    return this.settings.validation.required ? $t('Yes', undefined) : $t('No', undefined)
  }

  abstract optionsForGraphQL(): CustomFieldCustomFieldOptionInput[]
}
